import PortfolioContainer from "./PortfolioContainer/PortfolioContainer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./assets/boxicons/css/boxicons.min.css"
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";
import "hover.css";
import AstrologyPage from "./PortfolioContainer/ServiceComponents/AstrologyPage";
import VastuPage from "./PortfolioContainer/ServiceComponents/VastuPage";
import MarriagePage from "./PortfolioContainer/ServiceComponents/MarriagePage";


function App() {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div className="App">
      <ToastContainer />
        <Router>
          <Routes>
            <Route path="/" element={<PortfolioContainer />} />
            <Route path="/astro" element={<AstrologyPage />} />
            <Route path="/vastu" element={<VastuPage />} />
            <Route path="/marriage" element={<MarriagePage />} />
          </Routes>
        </Router>
    </div>
  );
}

export default App;
